import { render, staticRenderFns } from "./temporizador.vue?vue&type=template&id=3c06c105&scoped=true"
import script from "./temporizador.vue?vue&type=script&lang=js"
export * from "./temporizador.vue?vue&type=script&lang=js"
import style0 from "./temporizador.vue?vue&type=style&index=0&id=3c06c105&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c06c105",
  null
  
)

export default component.exports